(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antes-despues"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-baf-comparador]').forEach(function (comparador) {
    var manija = comparador.querySelector('[data-baf-manija]');
    var arrastrando = false;

    function calcularPorcentaje(clientX) {
      var rect = comparador.getBoundingClientRect();
      var porcentaje = ((clientX - rect.left) / rect.width) * 100;
      porcentaje = Math.max(0, Math.min(100, porcentaje));
      comparador.style.setProperty('--baf-porcentaje', porcentaje + '%');
    }

    function iniciar(evento) {
      arrastrando = true;
      calcularPorcentaje(evento.clientX);
    }

    function mover(evento) {
      if (!arrastrando) return;
      calcularPorcentaje(evento.clientX);
    }

    function terminar() {
      arrastrando = false;
    }

    comparador.addEventListener('pointerdown', iniciar);
    window.addEventListener('pointermove', mover);
    window.addEventListener('pointerup', terminar);
    manija.addEventListener('pointerdown', function (evento) {
      evento.stopPropagation();
      iniciar(evento);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-con-imagen"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.faq-seccion').forEach(function (seccion) {
    var tabs = seccion.querySelectorAll('[data-faq-tab]');
    var items = seccion.querySelectorAll('[data-faq-categoria]');

    function numerarVisibles(cat) {
      var contador = 1;
      items.forEach(function (item) {
        var visible = cat === null || item.getAttribute('data-faq-categoria') === cat;
        item.classList.toggle('faq-item--oculto', !visible);
        if (visible) {
          var numEl = item.querySelector('.faq-numero');
          if (numEl) numEl.textContent = contador + '. ';
          contador++;
          item.removeAttribute('open');
        }
      });
    }

    function activarTab(cat) {
      tabs.forEach(function (t) {
        var activo = t.getAttribute('data-faq-tab') === cat;
        t.classList.toggle('faq-tab--activo', activo);
        t.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
      numerarVisibles(cat);
    }

    if (tabs.length > 0) {
      var primera = tabs[0].getAttribute('data-faq-tab');
      activarTab(primera);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activarTab(this.getAttribute('data-faq-tab'));
        });
      });
    } else {
      numerarVisibles(null);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mensajes-rotativos"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ticker]').forEach(function (contenedor) {
    var mensajes = contenedor.querySelectorAll('[data-ticker-mensaje]');
    if (mensajes.length < 2) return;

    var velocidad = (parseInt(contenedor.dataset.velocidad, 10) || 3) * 1000;
    var indiceActual = 0;

    setInterval(function () {
      mensajes[indiceActual].classList.remove('mr-mensaje--activo');
      indiceActual = (indiceActual + 1) % mensajes.length;
      mensajes[indiceActual].classList.add('mr-mensaje--activo');
    }, velocidad);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-destacadas"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-resenas-destacadas]').forEach(function (contenedor) {
    var pista = contenedor.querySelector('[data-rd-pista]');
    var anterior = contenedor.querySelector('[data-rd-prev]');
    var siguiente = contenedor.querySelector('[data-rd-next]');
    if (!pista) return;

    var autoplay = contenedor.dataset.autoplay === 'true';
    var velocidad = (parseInt(contenedor.dataset.velocidad, 10) || 4) * 1000;
    var temporizador = null;

    function anchoPaso() {
      var primeraTarjeta = pista.querySelector('.rd-tarjeta');
      if (!primeraTarjeta) return pista.clientWidth;
      var estilo = window.getComputedStyle(pista);
      var gap = parseInt(estilo.columnGap || estilo.gap || 0, 10) || 0;
      return primeraTarjeta.getBoundingClientRect().width + gap;
    }

    function avanzar() {
      var paso = anchoPaso();
      var maximo = pista.scrollWidth - pista.clientWidth;
      if (pista.scrollLeft >= maximo - 2) {
        pista.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        pista.scrollBy({ left: paso, behavior: 'smooth' });
      }
    }

    function retroceder() {
      var paso = anchoPaso();
      if (pista.scrollLeft <= 2) {
        pista.scrollTo({ left: pista.scrollWidth, behavior: 'smooth' });
      } else {
        pista.scrollBy({ left: -paso, behavior: 'smooth' });
      }
    }

    function iniciarAutoplay() {
      if (!autoplay || pista.children.length < 2) return;
      temporizador = setInterval(avanzar, velocidad);
    }

    function detenerAutoplay() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        detenerAutoplay();
        avanzar();
        iniciarAutoplay();
      });
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        detenerAutoplay();
        retroceder();
        iniciarAutoplay();
      });
    }

    iniciarAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-resenas-carrusel"] && !Shopify.designMode) return;
  try {
    
class ResenaCarrusel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.rsc-track');
    this.tarjetas = Array.from(this.querySelectorAll('.rsc-tarjeta'));
    this.puntos = Array.from(this.querySelectorAll('.rsc-punto'));
    this.btnPrev = this.querySelector('.rsc-btn-prev');
    this.btnNext = this.querySelector('.rsc-btn-next');
    this.total = this.tarjetas.length;
    this.indice = 0;

    if (this.btnPrev) this.btnPrev.addEventListener('click', () => this.ir(this.indice - 1));
    if (this.btnNext) this.btnNext.addEventListener('click', () => this.ir(this.indice + 1));
    this.puntos.forEach((p, i) => p.addEventListener('click', () => this.ir(i)));

    var startX = 0;
    this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      var diff = startX - e.changedTouches[0].clientX;
      if (diff > 40) this.ir(this.indice + 1);
      else if (diff < -40) this.ir(this.indice - 1);
    });

    window.addEventListener('resize', () => this.actualizar(false));
    this.actualizar(false);
  }

  ir(indice) {
    this.indice = Math.max(0, Math.min(this.total - 1, indice));
    this.actualizar(true);
  }

  actualizar(animado) {
    var gap = 20;
    var anchoTarjeta = this.tarjetas[0] ? this.tarjetas[0].offsetWidth : 0;
    var offset = this.indice * (anchoTarjeta + gap);
    this.track.style.transition = animado ? 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
    this.track.style.transform = 'translateX(-' + offset + 'px)';
    this.puntos.forEach((p, i) => p.classList.toggle('rsc-punto--activo', i === this.indice));
    if (this.btnPrev) this.btnPrev.disabled = this.indice === 0;
    if (this.btnNext) this.btnNext.disabled = this.indice === this.total - 1;
  }
}

if (!customElements.get('resena-carrusel')) {
  customElements.define('resena-carrusel', ResenaCarrusel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-videos-testimonios"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCarrusel(wrapper) {
    var sectionId = wrapper.dataset.section;
    var carrusel = document.getElementById('svt-carrusel-' + sectionId);
    var btnPrev = document.getElementById('svt-prev-' + sectionId);
    var btnNext = document.getElementById('svt-next-' + sectionId);

    if (!carrusel) return;

    var tarjetas = Array.from(carrusel.querySelectorAll('.svt-tarjeta'));
    var total = tarjetas.length;
    var indiceActual = 0;
    var arrastre = { activo: false, inicioX: 0, scrollInicio: 0 };

    function getAncho(tarjeta) {
      return tarjeta.offsetWidth;
    }

    function getGap() {
      var estilo = window.getComputedStyle(carrusel);
      return parseInt(estilo.gap) || 12;
    }

    function actualizarCarrusel(indice, animado) {
      if (animado === undefined) animado = true;
      indiceActual = Math.max(0, Math.min(total - 1, indice));

      tarjetas.forEach(function(t, i) {
        t.classList.toggle('svt-tarjeta--central', i === indiceActual);
        if (i !== indiceActual) {
          var video = t.querySelector('video');
          if (video && !video.paused) {
            video.pause();
            t.classList.remove('svt-tarjeta--reproduciendo');
          }
        }
      });

      if (!animado) {
        carrusel.style.transition = 'none';
      } else {
        carrusel.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      }

      var gap = getGap();
      var offset = 0;
      for (var i = 0; i < indiceActual; i++) {
        offset += getAncho(tarjetas[i]) + gap;
      }

      var wrapperAncho = wrapper.offsetWidth;
      var tarjetaCentral = tarjetas[indiceActual];
      var centralizacion = offset - (wrapperAncho / 2) + (getAncho(tarjetaCentral) / 2);

      carrusel.style.transform = 'translateX(' + (-Math.max(0, centralizacion)) + 'px)';

      if (btnPrev) btnPrev.disabled = indiceActual === 0;
      if (btnNext) btnNext.disabled = indiceActual === total - 1;
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function() {
        actualizarCarrusel(indiceActual - 1);
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', function() {
        actualizarCarrusel(indiceActual + 1);
      });
    }

    tarjetas.forEach(function(tarjeta, i) {
      tarjeta.addEventListener('click', function(e) {
        if (e.target.closest('.svt-btn-mute')) return;

        if (i !== indiceActual) {
          actualizarCarrusel(i);
          return;
        }

        var video = tarjeta.querySelector('video');
        if (!video) return;

        if (video.paused) {
          document.querySelectorAll('.svt-video').forEach(function(v) {
            v.pause();
            v.closest('.svt-tarjeta').classList.remove('svt-tarjeta--reproduciendo');
          });
          video.muted = false;
          video.play();
          tarjeta.classList.add('svt-tarjeta--reproduciendo');
          var btn = tarjeta.querySelector('.svt-btn-mute');
          if (btn) btn.classList.remove('svt-btn-mute--silenciado');
        } else {
          video.pause();
          tarjeta.classList.remove('svt-tarjeta--reproduciendo');
        }
      });

      var btnMute = tarjeta.querySelector('.svt-btn-mute');
      if (btnMute) {
        btnMute.addEventListener('click', function(e) {
          e.stopPropagation();
          var video = tarjeta.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          btnMute.classList.toggle('svt-btn-mute--silenciado', video.muted);
        });
      }
    });

    wrapper.addEventListener('mousedown', function(e) {
      arrastre.activo = true;
      arrastre.inicioX = e.clientX;
      arrastre.indiceInicio = indiceActual;
    });

    window.addEventListener('mousemove', function(e) {
      if (!arrastre.activo) return;
      var diff = arrastre.inicioX - e.clientX;
      if (Math.abs(diff) > 5) e.preventDefault();
    });

    window.addEventListener('mouseup', function(e) {
      if (!arrastre.activo) return;
      arrastre.activo = false;
      var diff = arrastre.inicioX - e.clientX;
      if (diff > 50) actualizarCarrusel(indiceActual + 1);
      else if (diff < -50) actualizarCarrusel(indiceActual - 1);
    });

    var touchInicioX = 0;
    wrapper.addEventListener('touchstart', function(e) {
      touchInicioX = e.touches[0].clientX;
    }, { passive: true });

    wrapper.addEventListener('touchend', function(e) {
      var diff = touchInicioX - e.changedTouches[0].clientX;
      if (diff > 40) actualizarCarrusel(indiceActual + 1);
      else if (diff < -40) actualizarCarrusel(indiceActual - 1);
    });

    window.addEventListener('resize', function() {
      actualizarCarrusel(indiceActual, false);
    });

    actualizarCarrusel(0, false);
  }

  function init() {
    document.querySelectorAll('.svt-carrusel-wrapper').forEach(function(wrapper) {
      initCarrusel(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
